export const updateLanguage = (lang) => ({
  type: 'UPDATE_LANGUAGE',
  lang: lang
});
